import { ErrorBoundary } from '@sentry/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedRadarTemplateAtom, setRadarTemplateEditAtom } from '@/atoms/radar';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';

const RadarTemplateDuplicateMenuOptionBase = ({
  onClick,
  isDisabled,
}: {
  onClick?: () => void;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation('general');

  return <MenuItemWithIcon icon="Clone" disabled={isDisabled} onClick={onClick} text={t('duplicate')} />;
};

const RadarTemplateDuplicateMenuOptionWithData = () => {
  const { t } = useTranslation(['radar', 'general']);
  const selectedTemplate = useAtomValue(selectedRadarTemplateAtom);
  const setRadarTemplateEdit = useSetAtom(setRadarTemplateEditAtom);

  if (!selectedTemplate) {
    throw new Error('Unable to find selected radar template');
  }

  const { titleSettings } = selectedTemplate.definition;
  const translatedTemplateName = titleSettings.translate ? t(`templates.${titleSettings.title}`) : titleSettings.title;
  const duplicateName = `${translatedTemplateName} - ${t('copy', { ns: 'general' })}`;

  return (
    <RadarTemplateDuplicateMenuOptionBase
      onClick={() => setRadarTemplateEdit({ template: selectedTemplate, isDuplicate: true, name: duplicateName })}
    />
  );
};

export const RadarTemplateDuplicateMenuOption = () => (
  <ErrorBoundary fallback={<RadarTemplateDuplicateMenuOptionBase isDisabled />}>
    <Suspense fallback={<RadarTemplateDuplicateMenuOptionBase isDisabled />}>
      <RadarTemplateDuplicateMenuOptionWithData />
    </Suspense>
  </ErrorBoundary>
);
